import * as React from "react";
import { Card, Table, Button } from "antd";
import { NavLink } from "react-router-dom";

export interface MailingList {
  id: string;
  description: string;
  address: string;
  subscribedMembers: number;
}

export interface Props {
  mailinglists: (MailingList | null)[];
  loading?: boolean;
}

export interface State {}

const columns = [
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    render: (text: string, list: MailingList) => (
      <>
        <NavLink to={`/mailinglists/${list.id}`}>{list.description}</NavLink>
      </>
    )
  },
  {
    title: "Address",
    dataIndex: "address",
    key: "address",
    render: (text: string, list: MailingList) => <>{list.address}</>
  },
  {
    title: "Subscribed",
    dataIndex: "subscribedMembers",
    key: "subscribedMembers",
    render: (text: string, list: MailingList) => <>{list.subscribedMembers}</>
  }
];

export default class MailinglistList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <Card
        title="All Mailing lists"
        bodyStyle={{ padding: 0 }}
        style={{ marginTop: 30 }}
        extra={
          <NavLink to="/mailinglists/add">
            <Button>Create</Button>
          </NavLink>
        }
      >
        <Table
          rowKey="name"
          loading={this.props.loading}
          columns={columns}
          dataSource={this.props.mailinglists || []}
        />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MailinglistList/MailinglistList.tsx